import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "like",
  "use": "like-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\" id=\"like\">\n  <path d=\"M52 16.2C51.1 8 45.1 1.8 37.7 1.8a14 14 0 0 0-12 7c-2.5-4.4-6.8-7-11.6-7C6.8 1.8.8 7.8 0 16.2c0 .4-.3 2.4.4 5.5 1.1 4.6 3.6 8.7 7.2 12l18.1 16.5 18.5-16.5c3.6-3.3 6-7.4 7.2-12 .7-3.1.5-5 .4-5.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol